import { LandingPageCoverImage } from '@1po/1po-bff-fe-spec/generated/backoffice/landing_page_cover/model/LandingPageCoverImage';
// eslint-disable-next-line max-len
import { SetLandingPageCoverActiveRequest } from '@1po/1po-bff-fe-spec/generated/backoffice/landing_page_cover/request/SetLandingPageCoverActiveRequest';
// eslint-disable-next-line max-len
import { UploadLandingPageCoverRequest } from '@1po/1po-bff-fe-spec/generated/backoffice/landing_page_cover/request/UploadLandingPageCoverRequest';
// eslint-disable-next-line max-len
import { LandingPageCoverGetResponse } from '@1po/1po-bff-fe-spec/generated/backoffice/landing_page_cover/response/LandingPageCoverGetResponse';
// eslint-disable-next-line max-len
import { LandingPageCoverSetActiveResponse } from '@1po/1po-bff-fe-spec/generated/backoffice/landing_page_cover/response/LandingPageCoverSetActiveResponse';
import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import { RootState } from 'app/AppStore';
import {
  COVER_STATUS_ACTIVE,
  COVER_STATUS_INACTIVE,
  GET_LANDING_PAGE_COVERS_REQUEST,
  LANDING_PAGE_COVER_NAMESPACE,
  LandingPageCoverState,
  SET_LANDING_PAGE_COVER_ACTIVE_REQUEST,
  UPLOAD_LANDING_PAGE_COVER_REQUEST,
} from 'domains/landingPageCover/LandingPageCover.types';
import { FOUND, getDefaultSearchData, getSearchData } from 'utils';

// Init state
const initialState: LandingPageCoverState = {
  covers: getDefaultSearchData<LandingPageCoverImage[], unknown>(),
  isUploading: false,
};

// Saga actions
export const fetchLandingPageCoversRequestSaga = createAction(GET_LANDING_PAGE_COVERS_REQUEST);
export const uploadLandingPageCoverRequestSaga = createAction<UploadLandingPageCoverRequest>(
  UPLOAD_LANDING_PAGE_COVER_REQUEST,
);
export const setLandingPageCoverActiveRequestSaga = createAction<SetLandingPageCoverActiveRequest>(
  SET_LANDING_PAGE_COVER_ACTIVE_REQUEST,
);

// Slice
const slice = createSlice({
  name: LANDING_PAGE_COVER_NAMESPACE,
  initialState,
  reducers: {
    setLandingPageCoversResponse: (state, { payload }: PayloadAction<LandingPageCoverGetResponse>) => {
      state.covers = { searchStatus: FOUND, data: payload.covers };
    },
    setLandingPageCoverSetActiveResponse: (state, { payload }: PayloadAction<LandingPageCoverSetActiveResponse>) => {
      state.covers = { searchStatus: FOUND, data: payload.covers };
    },
    setIsUploading: (state, { payload }: PayloadAction<boolean>) => {
      state.isUploading = payload;
    },
  },
});

export const { setLandingPageCoversResponse, setLandingPageCoverSetActiveResponse, setIsUploading } = slice.actions;

// Selectors
const getCoversSearchData = (state: RootState) => state.landingPageCover.covers;

export const getLandingPageCovers = createSelector(
  getCoversSearchData,
  (covers): LandingPageCoverImage[] => getSearchData(covers) ?? [],
);

export const getActiveLandingPageCovers = createSelector(getLandingPageCovers, (covers): LandingPageCoverImage[] =>
  covers.filter((cover) => cover.status === COVER_STATUS_ACTIVE),
);

export const getInactiveLandingPageCovers = createSelector(getLandingPageCovers, (covers): LandingPageCoverImage[] =>
  covers.filter((cover) => cover.status === COVER_STATUS_INACTIVE),
);

export const getIsUploadingLandingPageCover = createSelector(
  (state: RootState) => state.landingPageCover.isUploading,
  (isUploading): boolean => isUploading,
);

export default slice.reducer;
